// Küfür filtresi - Türkçe küfürleri tespit eder ve filtreler

const profanityWords = [
  // A harfi - sadece gerçek küfürler
  'amk', 'amına', 'amcık', 'ananı', 'anana', 'anani', 'ananızı', 'ananıza',
  'aq', 'aw',
  'allahını', 'allahınızı', 'allahınıza',
  
  // S harfi - sadece gerçek küfürler
  'sikeyim', 'sikerim', 'sik', 'siki', 'sikin', 'sikini', 'sikine', 'sikimi',
  'siktiğim', 'siktiğin', 'siktiğini', 'siktiğine',
  'sikiyim', 'sikiyor', 'sikiyorum', 'sikiyorsun', 'sikiyoruz',
  
  // Ç harfi
  'çük', 'çükü', 'çükün', 'çükünü',
  
  // Diğer
  'orospu', 'orospusu', 'orospunun', 'orospuya', 'orospuyu',
  'piç', 'piçi', 'piçin', 'piçini',
  'göt', 'götü', 'götün', 'götünü', 'götüne',
  'yarrak', 'yarrağı', 'yarrağın', 'yarrağını',
  'pezevenk', 'pezevengi',
  'ibne', 'ibnesi',
  'kaltak',
  'kahpe',
  'fahişe',
];

// Küfür tespit fonksiyonu - sadece tam kelime eşleşmesi veya kelime başında
export const containsProfanity = (text) => {
  if (!text || typeof text !== 'string') return false;
  
  const lowerText = text.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Türkçe karakterleri normalize et
    .replace(/[^\w\s]/g, ' '); // Özel karakterleri boşlukla değiştir
  
  const words = lowerText.split(/\s+/);
  
  for (const word of words) {
    // Kelimeyi temizle (sadece harfler)
    const cleanWord = word.replace(/[^\w]/g, '');
    
    for (const profanity of profanityWords) {
      // Tam eşleşme veya kelime başında/ortasında küfür var mı kontrol et
      // Ama "adam" gibi kelimelerde "am" geçmemeli
      if (cleanWord === profanity || 
          (cleanWord.length > profanity.length && cleanWord.startsWith(profanity) && cleanWord[profanity.length].match(/[^a-zığüşöç]/)) ||
          (cleanWord.length > profanity.length && cleanWord.includes(profanity) && !cleanWord.match(/^[a-zığüşöç]+$/))) {
        // Ama "adam" gibi normal kelimeleri hariç tut
        if (cleanWord === 'adam' || cleanWord === 'adım' || cleanWord === 'adama' || cleanWord === 'adami') {
          continue;
        }
        return true;
      }
    }
  }
  
  return false;
};

// Küfürleri filtrele ve yıldızla değiştir - sadece gerçek küfürler
export const filterProfanity = (text) => {
  if (!text || typeof text !== 'string') return text;
  
  const normalizedText = text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  
  let filteredText = text;
  const words = normalizedText.split(/\s+/);
  
  words.forEach((word, index) => {
    const cleanWord = word.toLowerCase().replace(/[^\w]/g, '');
    
    // "adam" gibi normal kelimeleri hariç tut
    if (cleanWord === 'adam' || cleanWord === 'adım' || cleanWord === 'adama' || cleanWord === 'adami') {
      return;
    }
    
    for (const profanity of profanityWords) {
      // Tam eşleşme veya kelime başında küfür var mı
      if (cleanWord === profanity || 
          (cleanWord.length > profanity.length && cleanWord.startsWith(profanity))) {
        const originalWord = text.split(/\s+/)[index];
        const stars = '*'.repeat(Math.min(originalWord.length, 5));
        filteredText = filteredText.replace(new RegExp(originalWord.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi'), stars);
      }
    }
  });
  
  return filteredText;
};

// Küfürleri tespit et ve raporla (admin için) - sadece gerçek küfürler
export const detectProfanity = (text) => {
  if (!text || typeof text !== 'string') return { hasProfanity: false, words: [] };
  
  const lowerText = text.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\w\s]/g, ' ');
  
  const words = lowerText.split(/\s+/);
  const detectedWords = [];
  
  words.forEach(word => {
    const cleanWord = word.replace(/[^\w]/g, '');
    
    // "adam" gibi normal kelimeleri hariç tut
    if (cleanWord === 'adam' || cleanWord === 'adım' || cleanWord === 'adama' || cleanWord === 'adami') {
      return;
    }
    
    for (const profanity of profanityWords) {
      // Tam eşleşme veya kelime başında küfür var mı
      if (cleanWord === profanity || 
          (cleanWord.length > profanity.length && cleanWord.startsWith(profanity))) {
        if (!detectedWords.includes(profanity)) {
          detectedWords.push(profanity);
        }
      }
    }
  });
  
  return {
    hasProfanity: detectedWords.length > 0,
    words: detectedWords
  };
};

